import React from 'react';
import Modal from './Modal';
import { Button, DialogContent, DialogActions, Box, Typography } from '@mui/material';

interface CrochetStitchModalProps {
  onClose: () => void;
  onSelect: (stitchType: 'sc' | 'hdc' | 'dc') => void;
}

export default function CrochetStitchModal({ onClose, onSelect }: CrochetStitchModalProps) {
  const stitchTypes = [
    { value: 'sc', label: 'Single Crochet' },
    { value: 'hdc', label: 'Half Double Crochet' },
    { value: 'dc', label: 'Double Crochet' }
  ] as const;

  return (
    <Modal title="Choose Stitch Type" onClose={onClose}>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          {stitchTypes.map((stitch) => (
            <Button
              key={stitch.value}
              variant="outlined"
              fullWidth
              size="large"
              onClick={() => onSelect(stitch.value)}
              sx={{ py: 2 }}
            >
              <Typography variant="h6">{stitch.label}</Typography>
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Modal>
  );
}
